/**
 * Fila del editor de recetas — guardarraíl #7 + responsive (hallazgo B, smoke
 * 08/09 noche): el par "kg o [__] g" ensanchó la fila y en celular el modal
 * quedaba cortado con scroll horizontal. En <640px (breakpoint `sm`) la fila se
 * APILA: insumo a lo ancho / cantidad+unidad / captura alterna / Quitar (a la
 * derecha); nada fija un ancho mínimo sin prefijo sm:, así el modal nunca
 * excede 100vw. En ≥640px conserva el renglón único de siempre.
 */
import { altToBase, altUnitOf } from './recipeGuard';

export interface RecipeInsumoOpt { id: string; name: string; unit: string }

export function RecipeLineRow({ insumoId, qty, insumos, onPick, onQty, onRemove, removeClass }: {
  insumoId: string;
  qty: string;
  insumos: RecipeInsumoOpt[];
  onPick: (insumoId: string) => void;
  onQty: (qty: string) => void;
  onRemove: () => void;
  /** clase del botón Quitar (btnGhost del padre — no se exporta de BoutiqueViews). */
  removeClass?: string;
}) {
  const unit = insumos.find((i) => i.id === insumoId)?.unit ?? '';
  const alt = altUnitOf(unit);
  // Un insumoId sin <option> correspondiente (insumo borrado/desactivado, o línea
  // vacía) pintaba el select EN BLANCO. Fallback explícito para que SIEMPRE
  // despliegue algo.
  const known = insumos.some((i) => i.id === insumoId);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select className="input w-full min-w-0 sm:w-auto sm:min-w-[10rem] sm:flex-1" value={insumoId}
        onChange={(e) => onPick(e.target.value)}>
        {!known && (
          <option value={insumoId}>
            {insumoId ? '(insumo no disponible — elige otro)' : '— Elige un insumo —'}
          </option>
        )}
        {insumos.map((i) => <option key={i.id} value={i.id}>{i.name} ({i.unit})</option>)}
      </select>
      {/* !w-20: la clase .input fija width:100% y le gana a w-20 — con shrink-0
          era EL desborde original (el campo pedía toda la fila sin poder encoger). */}
      <input className="input !w-20 shrink-0" type="number" step="any" min="0" value={qty}
        onChange={(e) => onQty(e.target.value)} />
      {/* Guardarraíl (#7): la UNIDAD completa como sufijo del campo, nunca truncada. */}
      <span className="shrink-0 whitespace-nowrap text-xs font-medium text-slate-500"
        title={`Se descuenta en ${unit}`}>{unit}</span>
      {/* Captura alterna en g/ml para insumos en kg/L (guarda SIEMPRE en la unidad del insumo). */}
      {alt && (
        <label className="flex shrink-0 items-center gap-1 text-[11px] text-slate-400">
          o
          <input className="input !w-16 !py-1 text-xs" type="number" step="any" min="0" placeholder={alt}
            onChange={(e) => { const v = Number(e.target.value); if (Number.isFinite(v) && v >= 0) onQty(String(altToBase(v))); }} />
          {alt}
        </label>
      )}
      <button type="button" className={`${removeClass ?? ''} ml-auto shrink-0 sm:ml-0`} onClick={onRemove}>
        Quitar
      </button>
    </div>
  );
}
